import React from "react";
import SummaryCard from "./SummaryCard";

const CARD_DEFS = (summary) => [
  { label: "Present",    value: summary.present,   color: "#4CAF50" },
  { label: "Absent",     value: summary.absent,    color: "#F44336" },
  { label: "Half Day",   value: summary.half,      color: "#FF9800" },
  { label: "Week Off",   value: summary.weekOff,   color: "#2196F3" },
  { label: "Holiday",    value: summary.holiday,   color: "#2196F3" },
  { label: "Miss Punch", value: summary.missPunch, color: "#FF5722" },
  { label: "Pending",    value: summary.pending,   color: "#FF9800" },
  // { label: "Extra Work", value: summary.extra,     color: "#2E7D32" },
];

// Split flat array into rows of `size`
const chunk = (arr, size) =>
  Array.from({ length: Math.ceil(arr.length / size) }, (_, i) =>
    arr.slice(i * size, i * size + size),
  );

/**
 * SummaryStrip
 * Renders summary stats in a responsive 4-column grid.
 * Props:
 *   summary — { present, absent, half, weekOff, holiday, missPunch, pending, extra }
 */
export default function SummaryStrip({ summary }) {
  const rows = chunk(CARD_DEFS(summary), 4);

  console.log("summary", summary)
  return (
    <div className="px-3 pt-3 pb-2 bg-gray-50 flex flex-col gap-2 flex-shrink-0">
      {rows.map((row, ri) => (
        <div key={ri} className="grid grid-cols-4 gap-2">
          {row.map((c, ci) => (
            <SummaryCard key={ci} label={c.label} value={c.value} color={c.color} />
          ))}
          {/* fill empty slots so last row stays left-aligned */}
          {row.length < 4 &&
            Array.from({ length: 4 - row.length }).map((_, i) => (
              <div key={`empty-${i}`} />
            ))}
        </div>
      ))}
    </div>
  );
}